import { equal } from '@ember/object/computed';
import { computed } from '@ember/object';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import { Reason } from '@square/dashboard-protos/models/squareup/riskevaluation/external/external';
export const Status = new Enum('UNKNOWN_STATUS', 'NOT_ELIGIBLE', 'PENDING', 'ACTIVE');
export const RiskLevel = new Enum('UNKNOWN_LEVEL', 'NORMAL', 'MODERATE', 'HIGH');
export const RISK_RANKING = {
  [RiskLevel.MODERATE]: 1,
  [RiskLevel.HIGH]: 2
};
export const EvaluationResult = ProtoBaseModel.extend({
  status: attr(Status),
  level: attr(RiskLevel),
  reasons: repeated(Reason),
  createdAtMs: attr(Number),
  isActive: equal('status', Status.ACTIVE),
  isRisky: computed('level', 'isActive', function () {
    return this.isActive && [RiskLevel.MODERATE, RiskLevel.HIGH].includes(this.level);
  }),
  /**
   * When there are multiple Evaluation Results, for example in a split tender Transaction, we
   * want to show the most severe and use this ranking to determine the severity
   */
  rank: computed('level', 'isActive', function () {
    if (this.isActive) {
      return RISK_RANKING[this.level] || 0;
    }
    return 0;
  })
});
export const RiskEvaluationDetails = ProtoBaseModel.extend({
  evaluationResult: attr(EvaluationResult)
});
export default RiskEvaluationDetails;